import React from "react";
import { Modal, Grid, Typography, Button } from "@material-ui/core";
import withStyles from "@material-ui/core/styles/withStyles";
import styles from "./styles";
import rotatePhone from "../../images/rotatePhone.svg"
const NextQuestionModal = ({ classes, isNextQuestion, setIsNextQuestion, questionNumber }) => {

  return (
    <Modal
    open={isNextQuestion}
    onClick={() => setIsNextQuestion(false)}
  >
    <Grid container justify='center' alignItems='center' className={classes.modalContainer}>
      <Grid style={{ backgroundColor: '#fff', borderRadius: 10, width: "30%", padding: 30, textAlign: 'center' }}>
        <Typography className={classes.modalDescription}>
          { `Question Set ${questionNumber + 1}` }
        </Typography>
        <Button className={classes.nextButton}>
          Start
        </Button>
      </Grid>
    </Grid>
  </Modal>
  );
};

export default withStyles(styles)(NextQuestionModal);
